import clsx from 'classnames';

import styles from './FilterPillSkeleton.module.scss';

export const FilterPillSkeleton = () => {
	return (
		<div className={styles.filterPillSkeleton}>
			<div
				className={clsx(
					styles['filterPillSkeleton--pill'],
					styles['filterPillSkeleton--loadingEffect']
				)}
			/>
		</div>
	);
};
